/**
 * Zentralisierte Serialisierung (ADR-0002).
 * Nur von StorageEngine / Sync-Infrastructure importieren.
 */

export function serializeForKv(value) {
  if (value === undefined) return '';
  if (typeof value === 'string') return value;
  return JSON.stringify(value);
}

export function deserializeFromKv(raw) {
  if (raw == null || raw === '') return null;
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}
